<template>
  <div>
    <img class="logo" src="https://cf.denfield.io/assets/img/logo-transparent.png" />
  </div>
</template>

<script>
    export default {
        name: 'app-logo',
    }
</script>

<style lang="scss" scoped>
    .logo {
        @apply .block .mx-auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue